import { Checkbox } from 'cpool-components/input/Checkbox';
import { CheckboxSize } from 'cpool-components/input/Checkbox/types';
import type { FieldPath } from 'react-hook-form';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import type { SchemaCreditRequestForm } from '../schemas/creditRequestForm.schema';
import { useOnValueChanged } from '~/hooks/useOnValueChanged';

type Props = {
    name: FieldPath<SchemaCreditRequestForm>;
    translationPath: string;
    disabled?: boolean;
};

export const OptionCheckbox: React.FC<Props> = ({ disabled, name, translationPath }) => {
    const { t } = useTranslation();
    const { control, setValue } = useFormContext<SchemaCreditRequestForm>();
    const checked = useWatch<SchemaCreditRequestForm>({ name });
    const otherApplicantFieldName = (
        name.includes('applicant1')
            ? name.replace('applicant1', 'applicant2')
            : name.replace('applicant2', 'applicant1')
    ) as FieldPath<SchemaCreditRequestForm>;

    useOnValueChanged({
        onChange: () => {
            if (name.endsWith('excludeApplicant') && checked) {
                setValue(otherApplicantFieldName, false);
            }
        },
        values: [checked],
    });

    return (
        <Controller
            control={control}
            name={name}
            render={({ field }) => (
                <Checkbox
                    id={name}
                    size={CheckboxSize.MEDIUM}
                    // @ts-expect-error -- typescript cannot detect the translation path
                    label={t(translationPath)}
                    checked={field.value === true}
                    onChange={(event) => field.onChange(event.target.checked)}
                    onBlur={field.onBlur}
                    disabled={disabled}
                />
            )}
        />
    );
};
